export default class TimestampUtility {
  public static convertUnixTimestampToDate(unixTimestamp: number): Date {
    return new Date(unixTimestamp * 1000);
  }

  public static convertDateToUnixTimestamp(dateTime: Date) {
    return Math.floor(dateTime.getTime() / 1000);
  }

  public static dateTimeNowAsTimestamp(): number {
    const now = new Date();

    const roundedMinutes = this.roundToNearestFifteenMinutes(now.getMinutes());
    now.setMinutes(roundedMinutes, 0, 0); // Set seconds and milliseconds to 0
    return Math.floor(now.getTime() / 1000);
  }

  private static roundToNearestFifteenMinutes(minutes: number) {
    return Math.round(minutes / 15) * 15;
  }
}
